function isChecked ( value ) {

    switch ( value ) {

        case true:
        case "true":
        case "Y":
        case "y":

            return true;

        case false:
        case "false":
        case "N":
        case "n":
        case "":
        case 0:
        case "0":
        case null:
        case undefined:
            
            return false;

        default:

            return true;

    }
    
}

export default isChecked;
